export default {"src":"https://s.sylndr.com/c-0d6ce1e/_next/static/media/fromDownPayment.90abbcf8.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};